import { useContext } from "react";
import { PackingListContext } from "@RequestFormV2/sections/PackingList/context/PackingListProvider";

export function usePackingList() {
  const context = useContext(PackingListContext);
  if (!context) {
    throw new Error("usePackingList must be used within a PackingListProvider");
  }
  return context;
}
